import React, { Component } from 'react'
import { Autocomplete } from '@manychat/manyui'

import { Input } from './Input'
class TextAutocomplete extends Component {
  handleChange = ({ target }) => {
    const { option } = target
    const event = { target: { ...target, value: option.value } }
    this.props.onChange(event, true)
  }

  handleQueryChange = (e) => {
    const { value } = e.target
    this.props.onChange(e)
    this.props.fetchFieldValues(this.props.fieldDesc.id, value)
  }

  handleInputRef = (el) => el && el.select()

  render() {
    const { items, value, ...rest } = this.props
    const options = items.map((i) => {
      const value = `${i.value || i}`
      return { value, label: value }
    })

    return (
      <Autocomplete
        {...rest}
        ref={this.handleInputRef}
        options={options}
        value={value}
        onChange={this.handleChange}
        onQueryChange={this.handleQueryChange}
        customInput={<Input />}
        emptyLabel="No suggestions found"
        allowNew={false}
        noPortal
        noClearOnEmpty
      />
    )
  }
}

export default TextAutocomplete
